import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function ContentIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg width={width || 36} height={height || 36} viewBox="0 0 36 36">
      <g
        data-name="Ellipse 76"
        transform="translate(0 .005) translate(0 -.005)"
        fill="none"
        stroke="#bbb"
        strokeWidth={1.5}
      >
        <circle cx={18} cy={18} r={18} stroke="none" />
        <circle cx={18} cy={18} r={17.25} />
      </g>
      <text
        data-name="\uF15C"
        transform="translate(0 .005) translate(12 23.995)"
        fill={color || "#bbb"}
        fontSize={16}
        fontFamily="SegoeUI, Segoe UI"
        letterSpacing="-0.01em"
      >
        <tspan x={0} y={0}>
          {"\uF15C"}
        </tspan>
      </text>
    </svg>
  );
}
